import React from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { SECTIONS } from "@/lib/sections";
import { ChevronRight, ShieldAlert } from "lucide-react";

export const SectionGrid = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  return (
    <section data-testid="section-grid">
      <div className="mb-5 flex items-baseline justify-between">
        <h2 className="font-display text-xl font-bold tracking-tight text-[#0A192F]">{t("exploreJourney")}</h2>
        <span className="text-xs text-slate-400">{t("exploreSubtitle")}</span>
      </div>

      <div className="stagger grid grid-cols-2 gap-3.5">
        {SECTIONS.map(({ id, icon: Icon }) => (
          <button
            key={id}
            onClick={() => navigate(`/section/${id}`)}
            data-testid={`section-card-${id}`}
            className="group maqam-card flex flex-col items-start gap-4 p-5 text-left transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_16px_36px_-8px_rgba(10,25,47,0.16)] active:scale-[0.98]"
          >
            <div className="flex w-full items-center justify-between">
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[#0A192F] text-[#E9CE7D] transition-colors duration-300 group-hover:bg-[#112240]">
                <Icon size={22} strokeWidth={1.6} />
              </span>
              <ChevronRight
                size={16}
                className="text-slate-300 transition-all duration-300 group-hover:translate-x-0.5 group-hover:text-[#D4AF37]"
              />
            </div>
            <div className="min-w-0">
              <span className="block font-display text-[15px] font-bold leading-tight text-[#0A192F]">
                {t(`sec.${id}.title`)}
              </span>
              <span className="mt-1 block text-xs leading-snug text-slate-500">{t(`sec.${id}.desc`)}</span>
            </div>
          </button>
        ))}

        {/* Emergency SOS quick access */}
        <button
          onClick={() => navigate("/sos")}
          data-testid="section-card-sos"
          className="group col-span-2 flex items-center gap-4 rounded-[1.5rem] border-2 border-[#B42318]/25 bg-white p-5 text-left transition-all duration-300 hover:-translate-y-0.5 hover:border-[#B42318]/40 active:scale-[0.99]"
        >
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-white text-[#B42318] ring-2 ring-[#B42318]/30">
            <ShieldAlert size={22} strokeWidth={1.9} />
          </span>
          <div className="min-w-0 flex-1">
            <span className="block font-display text-[15px] font-bold text-[#B42318]">{t("sos.title")}</span>
            <span className="mt-0.5 block text-xs text-[#B42318]/70">{t("sos.hold")}</span>
          </div>
          <ChevronRight size={16} className="text-[#B42318]/50 transition-transform group-hover:translate-x-0.5" />
        </button>
      </div>
    </section>
  );
};
